import React from 'react';
import { TIPO_USUARIO as tipoUsuario } from '../../../consts/tipoUsuario';
import { DesktopOrTabletContainer, MobileContainer } from '../../../responsiveTools/ResponsiveContainers';

import HomeInterno from './DesktopHome/HomeInterno';
import HomePaciente from './DesktopHome/HomePaciente';
import HomeCliente from './DesktopHome/HomeCliente';
import MobileHomeInterno from './MobileHome/MobileHomeInterno';
import MobileHomePaciente from './MobileHome/MobileHomePaciente';
import MobileHomeCliente from './MobileHome/MobileHomeCliente';
import { Comunicados } from '../../Comunicados/components/Comunicados';

export default function Home ( { idTipoUsuario } ) {
    const noEjecutoComunicados = !sessionStorage.getItem('noEjecutoComunicados') || sessionStorage.getItem('noEjecutoComunicados') === 'true';

    return (
        <>
        {!!noEjecutoComunicados && <Comunicados />}
            <DesktopOrTabletContainer>
                { (idTipoUsuario == tipoUsuario.INTERNO) && <HomeInterno /> }
                { (idTipoUsuario == tipoUsuario.PACIENTE) && <HomePaciente /> }
                { (idTipoUsuario == tipoUsuario.CLIENTE) && <HomeCliente /> }
            </DesktopOrTabletContainer>
            <MobileContainer>
                { (idTipoUsuario == tipoUsuario.INTERNO) && <MobileHomeInterno /> }
                { (idTipoUsuario == tipoUsuario.PACIENTE) && <MobileHomePaciente /> }
                { (idTipoUsuario == tipoUsuario.CLIENTE) && <MobileHomeCliente /> }
            </MobileContainer>
        </>
    )
};